export default __webpack_public_path__ + "static/media/face.2c7238dc.ogg";